import React from "react"
import { useTranslation } from "react-i18next"

import { useTimeDifferenceText } from "shared/lib/useTimeDifferenceText"
import { WithClassName } from "shared/types/WithClassName"
import { Readonly } from "shared/ui/readonly/Readonly"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export interface ProjectFormLastChangedProps extends WithClassName {
  children?: React.ReactNode
}

export const ProjectFormLastChanged = React.memo(
  ({ children, className }: ProjectFormLastChangedProps) => {
    const { t } = useTranslation()
    const { isLoading, model } = useProjectFormContext()
    const projectData = model?.core.data.project?.data

    const timeDifference = useTimeDifferenceText(
      projectData?.lastChanged ?? projectData?.updatedAt
    )

    const displayContent = children ?? timeDifference

    if (isLoading) {
      return null
    }

    return (
      <Readonly.Root className={className}>
        <Readonly.Label>{t("General.LastChanged")}</Readonly.Label>
        <Readonly.Value>{displayContent}</Readonly.Value>
      </Readonly.Root>
    )
  }
)

ProjectFormLastChanged.displayName = "ProjectFormLastChanged"
